import React, { useEffect, useState, useContext } from 'react';
import { WorkspaceContext } from '../context/WorkspaceContext'; // Importar el contexto
import AssessmentServices from '../api/assessmentServices';
import AssessmentForm from '../components/AssessmentForm';
import { AssessmentProvider } from '../context/AssessmentContext';
import '../styles/Table.css';

function Assessments({ apiToken }) {
  const [assessmentId, setAssessmentId] = useState(null); 
  const { selectedWorkspace } = useContext(WorkspaceContext); // Obtener el workspace seleccionado del contexto
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mode, setMode] = useState('hidden');

  // Cargar los assessments según el workspace seleccionado
  useEffect(() => {
    async function fetchData() {
      if (!selectedWorkspace) return; // No hacer nada si no hay workspace seleccionado

      try {
        const l = await AssessmentServices.listAssessments(selectedWorkspace.id); // Pasar el ID del workspace
        setList(l);
      } catch (error) {
        console.error('Error al cargar los assessments:', error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [selectedWorkspace, apiToken]); // Re-ejecutar el efecto si cambia el workspace o el token

  // Manejar la eliminación de assessments
  const handleDeleteAssessment = async (id) => {
    await AssessmentServices.deleteAssessment(id);
    const l = await AssessmentServices.listAssessments(selectedWorkspace.id);
    setAssessmentId(null);
    setList(l);
  };

  // Manejar la edición de assessments
  const handleEditAssessment = async (assessment) => {
    setAssessmentId(assessment.id);
    setMode('edit');
  };

  // Mostrar mensaje si no hay workspace seleccionado
  if (!selectedWorkspace) {
    return <div>Por favor seleccione un workspace.</div>;
  }

  if (loading) {
    return <div>Cargando datos...</div>;
  }

  return (
    <div>
      <h2>Assessments - {selectedWorkspace.name}</h2> {/* Mostrar el nombre del workspace */}
      {mode === 'hidden' && (
        <button onClick={() => setMode('edit')}>
          <span role="img" aria-label="add">➕</span>
        </button>
      )}
      {mode === 'edit' && (
        <>
          <button onClick={() => { setMode('hidden'); setAssessmentId(null); }}>
            <span role="img" aria-label="cancel">❌</span>
          </button>
          <br/>
          <br/>
        </>
      )}
      <AssessmentProvider assessmentId={assessmentId}>
        <AssessmentForm assessmentId={assessmentId} mode={mode} />
      </AssessmentProvider>      
      <br />
      {mode === 'hidden' && (
        <table>
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Slug</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>
            {list.map((as) => (
              <tr key={as.id}>
                <td>{as.name}</td>
                <td>{as.slug}</td>
                <td>
                  <button onClick={() => handleEditAssessment(as)}>
                    <span role="img" aria-label="edit">✏️</span>
                  </button>
                  <button onClick={() => handleDeleteAssessment(as.id)}>
                    <span role="img" aria-label="delete">🗑️</span>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default Assessments;
